<template>
  <v-form>
    <div class="mb-4">
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-autocomplete-comprador
            required
            label="Local de faturamento"
            class="required rounded-tag-small"
            :error="$v.cotacao.comprador.$error"
            @blur="$v.cotacao.comprador.$touch()"
            v-model="cotacao.comprador"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-autocomplete-comprador
            required
            label="Local de entrega"
            class="required rounded-tag-small"
            :error="$v.cotacao.compradorEntrega.$error"
            @blur="$v.cotacao.compradorEntrega.$touch()"
            v-model="cotacao.compradorEntrega"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="d-flex" cols="12" sm="4">
          <px-select-enum v-model="cotacao.tipoFrete"
                          class="rounded-tag-small"
                          label="Tipo de frete"
                          :items="tiposFretes"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <px-date-picker label="Prazo de entrega"
                          input-class="required rounded-tag-small"
                          :error="$v.cotacao.prazoEntrega.$error"
                          @blur="$v.cotacao.prazoEntrega.$touch()"
                          v-model="cotacao.prazoEntrega"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <px-date-picker label="Prazo de resposta"
                          input-class="rounded-tag-small"
                          v-model="cotacao.validade"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="d-flex" cols="12" sm="6">
          <px-select-enum v-model="cotacao.formaPagamento" :items="formasPagamentos"
                          class="rounded-tag-small"
                          label="Forma pagamento"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <px-autocomplete-prazo-pagamento v-model="cotacao.prazoPagamento"
                                           class="rounded-tag-small"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-autocomplete-projeto
            class="rounded-tag-small"
            v-model="cotacao.projeto"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-autocomplete-centro-custo
            class="rounded-tag-small"
            v-model="cotacao.centroCusto"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
          outlined
          rows="2"
          v-model="cotacao.observacaoInterna"
          label="Observações internas"
          counter="1500"
          class="rounded-tag-small"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            rows="3"
            v-model="cotacao.observacao"
            label="Observações externas"
            counter="1500"
            class="rounded-tag-small"
          >
            <template v-slot:append-outer>
              <px-anexo v-model="cotacao.arquivos"
                        :max="3">
              </px-anexo>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
       <v-row class="mt-3" dense>
        <v-col cols="12">
          <div class="font-weight-bold body-2">
            Finalidade da compra
          </div>
          <v-radio-group
            row dense
            v-model="cotacao.finalidadeCompra"
            class="d-flex"
          >
            <v-radio
              v-for="finalidade in finalidades"
              :key="finalidade.key"
              :label="finalidade.description"
              :value="finalidade.key"/>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-btn color="primary"
             class="rounded-tag-small normal-btn-text elevation-0"
            @click="enviar">
            Continuar
      </v-btn>
      <v-btn text
             class="normal-btn-text"
             @click="onClickCancel">
             Cancelar
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { TipoFrete, FormaPagamento, FinalidadeCompra } from 'px-business-components';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    cotacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tiposFretes: TipoFrete.values,
      formasPagamentos: FormaPagamento.values,
      finalidades: FinalidadeCompra.values,
      finalidadeCompra: FinalidadeCompra.keys.USO_CONSUMO.key,
    };
  },
  methods: {
    enviar() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('ready');
    },
    onClickCancel() {
      this.$emit('cancel');
    },
  },
  validations: {
    cotacao: {
      comprador: {
        required,
      },
      compradorEntrega: {
        required,
      },
      prazoEntrega: {
        required,
      },
    },
  },
};
</script>
